import { CORE_PROJECT_CONTENT_SOURCES } from '../project/project_content_registry.mjs';

const coreOwners = new Set(CORE_PROJECT_CONTENT_SOURCES.map(source => source.ownerId));
/** Whole active sheet only: no implicit omissions or product IDs in the host. */
export function gpuPreviewOwners(manifest, supportsOwner, emptyOwner = null) {
  if (!manifest || !Array.isArray(manifest.sources)) throw new Error('Zeichnungsinhalt ist nicht verfügbar.');
  const owners = manifest.sources.filter(source => !coreOwners.has(source.ownerId)
    && source.collections.some(collection => collection.count > 0)).map(source => source.ownerId);
  if (!owners.length && emptyOwner && supportsOwner(emptyOwner)) return [emptyOwner];
  if (!owners.length || owners.some(owner => !supportsOwner(owner))) {
    throw new Error('Diese Zeichnungsebene enthält noch nicht unterstützte Systeme oder keine unterstützten Produktobjekte. Bitte die normale Planansicht verwenden.');
  }
  // Include the active GPU tool even before its first committed object exists.
  if (emptyOwner && supportsOwner(emptyOwner)) owners.push(emptyOwner);
  return [...new Set(owners)];
}

export function sameGpuPreviewContext(a, b) {
  return Boolean(a && b && a.project === b.project && a.sheet === b.sheet
    && a.revision === b.revision && a.geometryRevision === b.geometryRevision && a.view === b.view);
}

/** The separate legacy preview editor still edits one owner at a time. */
export function gpuPreviewOwner(manifest, supportsOwner, emptyOwner = null) {
  const owners = gpuPreviewOwners(manifest, supportsOwner, emptyOwner);
  if (owners.length !== 1) throw new Error('Bitte gemischte Systeme in der normalen GPU-Planansicht bearbeiten.');
  return owners[0];
}
